export default __webpack_public_path__ + "static/prof-web-c84e3a842dde8ca4f9405c0a214efc07.png";